/** Sidebar nav paths that require an approved business before use. */
export const BUSINESS_OPERATIONAL_NAV_PATHS = [
  "/appointments",
  "/slot-requests",
  "/customers",
  "/messages",
  "/services",
  "/providers",
  "/finance",
  "/support",
  "/ad-campaigns",
] as const

/** Route prefixes guarded when no business exists or approval is pending. */
export const BUSINESS_OPERATIONAL_PATH_PREFIXES = [
  ...BUSINESS_OPERATIONAL_NAV_PATHS,
  "/income-management",
  "/transactions",
  "/reports",
] as const

export function isBusinessOperationalPath(pathname: string): boolean {
  return BUSINESS_OPERATIONAL_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}

export function isBusinessOperationalNavPath(path: string): boolean {
  return BUSINESS_OPERATIONAL_NAV_PATHS.includes(
    path as (typeof BUSINESS_OPERATIONAL_NAV_PATHS)[number]
  )
}
